import { useCallback } from 'react';

import ConfirmationPopover, { ControlledConfirmationPopover } from '@/components/ConfirmationPopover';
import { PureSwitch } from '@/components/form/Switch';
import { useAppAlert } from '@Components/AppAlert';
import { useGrid } from '@Components/Grid';
import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function DefaultToggle({ info }) {
  const { events: { handleUpdateEntry }, definitions: { entityName } } = useGrid()
  const { handleSuccess } = useAppAlert()
  const { row, field, value } = getInfo(info)

  const handleUpdateDefault = useCallback(async () => {
    handleUpdateEntry({ id: row.id, [field]: !value })
    handleSuccess(`${entityName} edited!`)
  }, [handleUpdateEntry, field, row, value, handleSuccess, entityName])

  if (row.default) {
    return <>
      <ConfirmationPopover
        target={<PureSwitch value={row.default} />}
        title={<span>Change {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.name || row.description}`}</i> to default</span>}
      >
        <h6>Each site must have at least one default allocation. Change another entry to default to disable this.</h6>
      </ConfirmationPopover>
    </>
  }

  return <>
    <ControlledConfirmationPopover
      target={<PureSwitch value={row.default} />}
      title={<span>Change {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.name || row.description}`}</i> to default</span>}
      onSubmit={handleUpdateDefault}
    >
      <div>
        <p><strong>Are you sure you want to do that?</strong></p>
        <h6>All the organic traffic will be attributed automatically to this Allocation.</h6>
      </div>
    </ControlledConfirmationPopover>
  </>
}
